import FD from '../../../RestAPI/fetchData';
import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const saveQuestionAttemptStats = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/saveStats`, data);
};
const fetchChapterNameById = async (data) => {
  return await FD.callAPI(`${config.backend_api}/esg/chapter-by-id`, data);
};
const pdfDownloadViaEmail = async (data) => {
  return await FD.callAPI(`${config.backend_api}/esg/question/pdf-download-via-email`, data);
};
const fetchSavedQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/getFavQuestions`, data);
};
const saveQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/saveQuestion`, data);
};
const deleteSavedQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/unsaveQuestion`, data);
};

const fetchQuestionsReadingWise = async (data) => {
  return await GetData.callAPI(`${config.backend_api}/exams/frm/question-bank/all-questions`, data);
};
const reportQuestion = async (data) => {
  return await FD.callAPI(`${config.backend_api}/frm_question_bank/reportQuestion`, data);
};
module.exports = {
  saveQuestionAttemptStats,
  fetchQuestionsReadingWise,
  fetchChapterNameById,
  pdfDownloadViaEmail,
  fetchSavedQuestion,
  saveQuestion,
  deleteSavedQuestion,
  reportQuestion,
};



// WEBPACK FOOTER //
// ./src/views/FRM-V2/Questionbank/QuestionView/ApiService.js